<template>
    <v-list tile subheader>
        <template v-for="heading in docs">
            <v-subheader>{{heading.name}}</v-subheader>
            <v-divider></v-divider>
            <template  v-for="doc in heading.children">
                <v-list-item :key="doc.link" :to="{name: doc.route, params: {name: doc.link}}">
                    <v-list-item-title :key="doc.link">
                        {{doc.title}}
                    </v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
            </template>
        </template>
    </v-list>
</template>
<script>
    export default {
        props: ['docs']
    }
</script>
<style scoped>

</style>